import Vue from 'vue'
import App from './App.vue'

import 'document-register-element/build/document-register-element'

// Allow app to be rendered in custom element
import vueCustomElement from 'vue-custom-element'

// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// Vuex
import {store} from './store'
App.store = store

// Embed YouTube
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed);

//Vue.use(VueAxios, axios)
Vue.use(vueCustomElement)

Vue.config.productionTip = true

Vue.customElement('video-playlist', App)
